import { CalendarEvent, ics as createICSDataUrl } from 'calendar-link';

const ICS_DATA_URL_PREFIX = 'data:text/calendar;charset=utf8,';

type CalendarFileDisposition = 'attachment' | 'inline';

interface CalendarFileOptions {
  disposition?: CalendarFileDisposition;
  filename?: string;
}

export function buildCalendarFilename(startTime: Date, label = 'calendar') {
  const date = startTime.toISOString().slice(0, 10).replace(/-/g, '');
  return `meeting-${date}-${label}.ics`;
}

export function buildICSContent(event: CalendarEvent) {
  const dataUrl = createICSDataUrl(event);

  if (!dataUrl.startsWith(ICS_DATA_URL_PREFIX)) {
    return dataUrl;
  }

  return decodeURIComponent(dataUrl.slice(ICS_DATA_URL_PREFIX.length));
}

export function openCalendarFile(event: CalendarEvent, filename = buildCalendarFilename(new Date(event.start), 'calendar')) {
  window.location.assign(buildCalendarFileUrl(event, { disposition: 'inline', filename }));
}

export function downloadICSFile(event: CalendarEvent, filename = buildCalendarFilename(new Date(event.start), 'ics')) {
  const link = document.createElement('a');
  link.href = buildCalendarFileUrl(event, { disposition: 'attachment', filename });
  link.rel = 'noopener';
  link.click();
}

export function createICSFile(event: CalendarEvent) {
  downloadICSFile(event);
}

function buildCalendarFileUrl(event: CalendarEvent, options: CalendarFileOptions = {}) {
  const end = event.end ? new Date(event.end) : null;

  if (!end || Number.isNaN(end.getTime())) {
    throw new Error('Calendar event requires a valid end time.');
  }

  const params = new URLSearchParams({
    title: event.title,
    start: new Date(event.start).toISOString(),
    end: end.toISOString(),
    disposition: options.disposition ?? 'inline',
    filename: options.filename ?? buildCalendarFilename(new Date(event.start)),
  });

  if (event.description) {
    params.set('description', event.description);
  }

  if (event.location) {
    params.set('location', event.location);
  }

  return `/api/calendar?${params.toString()}`;
}
